var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from 'root/src/client/v2/common/components/ui/tooltip';
import { toast } from 'root/src/client/v2/common/components/ui/sonner';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// Masks a secret (key/code) showing only the first/last 4 chars; click the value to copy,
// toggle the eye to reveal/hide. Layout mirrors the share-link card: icon left, copy at the end.
const maskValue = (value) => {
    if (value.length <= 8) {
        return '•'.repeat(Math.max(value.length, 4));
    }
    return `${value.slice(0, 4)}${'•'.repeat(Math.min(value.length - 8, 16))}${value.slice(-4)}`;
};
const iconButtonClass = 'flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-white/[0.06] hover:text-foreground';
export const SecretCopyField = ({ value, label, className }) => {
    const [revealed, setRevealed] = useState(false);
    const [copied, setCopied] = useState(false);
    const copy = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield navigator.clipboard.writeText(value);
            setCopied(true);
            toast.success('Key copied to clipboard');
            setTimeout(() => setCopied(false), 1500);
        }
        catch (error) {
            toast.error('Could not copy to clipboard');
        }
    });
    return (<div className={cn('w-full', className)}>
			{label && <span className="mb-1.5 block text-[11px] font-medium text-muted-foreground">{label}</span>}
			<TooltipProvider delayDuration={200}>
				<div className="flex items-center gap-2 rounded-xl border border-solid border-white/[0.08] bg-white/[0.03] px-3 py-2 transition-colors hover:border-white/20">
					<VpnKeyOutlinedIcon sx={{ fontSize: 18 }} className="flex-shrink-0 text-neon-amber"/>

					<Tooltip>
						<TooltipTrigger asChild>
							<button type="button" onClick={copy} data-wg-notranslate aria-label="Copy key" className="min-w-0 flex-1 truncate text-left font-mono text-sm text-foreground">
								{revealed ? value : maskValue(value)}
							</button>
						</TooltipTrigger>
						<TooltipContent>{copied ? 'Copied!' : 'Click to copy'}</TooltipContent>
					</Tooltip>

					<Tooltip>
						<TooltipTrigger asChild>
							<button type="button" onClick={() => setRevealed(current => !current)} aria-label={revealed ? 'Hide key' : 'Reveal key'} className={iconButtonClass}>
								{revealed ? <VisibilityOffIcon sx={{ fontSize: 16 }}/> : <VisibilityIcon sx={{ fontSize: 16 }}/>}
							</button>
						</TooltipTrigger>
						<TooltipContent>{revealed ? 'Hide' : 'Reveal'}</TooltipContent>
					</Tooltip>

					<Tooltip>
						<TooltipTrigger asChild>
							<button type="button" onClick={copy} aria-label="Copy key" className={iconButtonClass}>
								{copied
            ? <CheckIcon sx={{ fontSize: 16 }} className="text-neon-green"/>
            : <ContentCopyIcon sx={{ fontSize: 16 }}/>}
							</button>
						</TooltipTrigger>
						<TooltipContent>{copied ? 'Copied!' : 'Copy'}</TooltipContent>
					</Tooltip>
				</div>
			</TooltipProvider>
		</div>);
};
